import { getLanguagesLabels } from '#app/lib/languages/languages_labels.ts'
import { objectEntries, objectKeys } from '#app/lib/utils.ts'
import languagesData from '#assets/js/languages_data'

export const regionify: Record<string, string> = {}

for (const [ lang, languageData ] of objectEntries(languagesData)) {
  const { defaultRegion } = languageData
  regionify[lang] = defaultRegion
}

export async function getTranslatedLanguagesData () {
  const langs = objectKeys(languagesData)
  const languagesLabels = await getLanguagesLabels(langs)
  return objectEntries(languagesLabels)
  .map(([ lang, label ]) => {
    return {
      lang,
      label,
      completion: languagesData[lang].completion,
    }
  })
  .sort((a, b) => a.label > b.label ? 1 : -1)
}

export const activeLangs = objectKeys<typeof languagesData>(languagesData)

export type UserLang = typeof activeLangs[number]

// Generated with https://w.wiki/5cVs
const rtlLang = new Set([ 'ace', 'ady', 'aeb', 'ar', 'arc', 'arq', 'ary', 'arz', 'az', 'bej', 'bjn', 'bm', 'bqi', 'bsk', 'ckb', 'dar', 'diq', 'dv', 'ett', 'fa', 'ff', 'glk', 'ha', 'hbo', 'he', 'jv', 'kbd', 'khw', 'kk', 'kr', 'ks', 'ku', 'kum', 'ky', 'lad', 'lki', 'lrc', 'luz', 'min', 'ms', 'mzn', 'non', 'nqo', 'ota', 'otk', 'pa', 'pnb', 'ps', 'qya', 'rif', 'sd', 'sdh', 'shi', 'shy', 'sw', 'syc', 'ta', 'tg', 'tk', 'tru', 'tzm', 'ug', 'uz', 'uzs', 'wbl', 'wo', 'xpu' ])

export function getTextDirection (lang = 'en') {
  const languageFamilyCode = lang.split('-')[0]
  return rtlLang.has(languageFamilyCode) ? 'rtl' : 'ltr'
}
